export function treacheryValues(){
    // autoload later
    return {
        2: 1,
        7: 2,
        10: 3,
        13: 4,
        15: 5
    }
}

export function treacheryInfo(){
    return ''
}
